import { createActions } from 'redux-actions';

const MESSAGE_DELAY = 3000;

export const {
  toastMessenger: { pushMessage, popMessage },
} = createActions({
  TOAST_MESSENGER: {
    PUSH_MESSAGE: (type, message) => ({
      type,
      message,
    }),
    POP_MESSAGE: () => {},
  },
});

export const showError = (error, duration = null) => dispatch => {
  setTimeout(() => dispatch(popMessage()), duration || MESSAGE_DELAY);

  dispatch(pushMessage('error', error.message));
};

export const showSuccess = (message, duration = null) => dispatch => {
  setTimeout(() => dispatch(popMessage()), duration || MESSAGE_DELAY);

  dispatch(pushMessage('success', message));
};
